<template>
    <div>
        <patient-login :isDialog=false loginRedirect="home"></patient-login>
    </div>
</template>

<script>
    import PatientLogin from "../components/Login/PatientLogin";

    export default {
        name: "Login",
        components: {
            PatientLogin
        },
        data() {
            return {}
        }
    }
</script>


<style scoped>
    .verifyOtpForm input {
        font-size: 30px;
        text-align: center !important;
    }

    .otpFields {
        display: inline-block;
        width: 35px;
        margin: 8px;
        font-size: 30px;
        text-align: center !important;
    }
</style>